import { createContext } from "react"

export const StudyContext = createContext(
    {
        mistakeAction: () => { },
        continueAction: () => { }
    }
)
